import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export async function rolecreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createrole`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function rolelist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listrole`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function roleview(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewrole/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function roleupdate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/updaterole`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function roledelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deleterole`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function rolevalidate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/validaterole`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}



export async function branchcreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createbranch`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function branchlist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listbranch`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function branchview(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewbranch/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function branchupdate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/updatebranch`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function branchdelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deletebranch`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function branchvalidate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/validatebranch`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}



export async function desicreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createdesignation`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function desilist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listdesignation`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function desiview(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewdesignation/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function desiupdate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/updatedesignation`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function desidelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deletedesignation`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function desivalidate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/validatedesignation`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function schemecreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createscheme`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function schemelist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listscheme`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function schemedetail(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewscheme/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function schemedelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deletescheme`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function religioncreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createreligion`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function religionlist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listreligion`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function religionview(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewreligion/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function religionupdate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/updatereligion`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function religiondelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deletereligion`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function religionvalidate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/validatereligion`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}




export async function castecreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createcaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function castelist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listcaste`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function casteview(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewcaste/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function casteupdate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/updatecaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function castedelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deletecaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function castevalidate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/validatecaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}




export async function subcastecreate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/createsubcaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function subcastelist() {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/listsubcaste`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function subcasteview(id) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .get(`${baseUrl}/viewsubcaste/${id}`, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


export async function subcasteupdate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/updatesubcaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function subcastedelete(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/deletesubcaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}

export async function subcastevalidate(data) {
    try {
        const header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
        };
        return await axios
            .post(`${baseUrl}/validatesubcaste`, data, { headers: header })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                catcherror(error);
            });
    } catch (error) {
        catcherror(error);
    }
}


function catcherror(error) {
    console.log(error);
    if (error.response.status === 401) {
        localStorage.clear();
        window.location.reload();
        <Navigate to={"/login"} />;
    } else if (error.response.status === 422) {
        Swal.fire({
            title:
                "There are few errors occured while inserting/updating the data to the database.",
            showCancelButton: false,
            confirmButtonColor: "#d71635",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
        });
    } else if (error.response.status === 0) {
        toast.error(error.message);
    } else if (error.response.status === 500) {
        toast.error(error.response.statusText);
    } else if (
        error.response.status !== 200 &&
        error.response.data.status === false &&
        error.response.data.code !== 200
    ) {
        toast.error(error.response.data.message);
    } else if (error.request) {
        toast.error(error.request.statusText);
    } else {
        toast.error(error.message);
    }
}
